'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
}; // Styles
// Components


var _templateObject = _taggedTemplateLiteral(['\n  background: ', ';\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);\n  border-radius: 3px;\n  user-select: none;\n\n  ', ';\n'], ['\n  background: ', ';\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);\n  border-radius: 3px;\n  user-select: none;\n\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    border-radius: 0px;\n    box-shadow: 0;\n  '], ['\n    border-radius: 0px;\n    box-shadow: 0;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../libs/colors');

var _media = require('../../libs/media');

var _Item = require('./components/Item.Menu');

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Menu = function Menu(_ref) {
  var options = _ref.options,
      className = _ref.className,
      open = _ref.open;
  return _react2.default.createElement('div', {
    className: className
  }, options.map(function (option) {
    return _react2.default.createElement(_Item2.default, _extends({
      key: option.id,
      open: open
    }, option));
  }));
};

Menu.propTypes = {
  options: _propTypes2.default.array,
  className: _propTypes2.default.string,
  open: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)])
};
Menu.defaultProps = {
  options: [],
  open: 'none'
};
var StyledMenu = (0, _styledComponents2.default)(Menu)(_templateObject, _colors.white, _media.media.s(_templateObject2));
exports.default = StyledMenu;